// https://github.com/mattdesl/canvas-sketch-util

// https://github.com/mattdesl/canvas-sketch

const canvasSketch = require("canvas-sketch");
const { lerp, mod } = require("canvas-sketch-util/math");
const random = require("canvas-sketch-util/random");

// random.setSeed(window.fxhash);
random.setSeed(random.getRandomSeed());

const features = {
  dimensions: random.weightedSet([
    {
      value: "landscape",
      weight: 30,
    },
    { value: "square", weight: 70 },
    { value: "portrait", weight: 100 },
  ]),
  colorMode: random.weightedSet([
    {
      value: "a",
      weight: 70,
    },
    { value: "b", weight: 100 },
  ]),
  gridSize: random.weightedSet([
    {
      value: "smol",
      weight: 50,
    },
    { value: "med", weight: 80 },
    { value: "xl", weight: 30 },
  ]),
  margin: random.weightedSet([
    {
      value: "smol",
      weight: 0,
    },
    { value: "med", weight: 100 },
    { value: "xl", weight: 0 },
  ]),
  scale: random.weightedSet([
    {
      value: "smol",
      weight: 100,
    },
    { value: "big", weight: 0 },
  ]),
  colorSet: random.weightedSet([
    { value: "cool", weight: 90 },
    { value: "green", weight: 20 },
  ]),
};

console.log(features.dimensions);
console.log(features.colorMode);
console.log(features.gridSize);

const settings = {
  suffix: random.getSeed(),
  animate: true,
  playing: true,
  // dimensions: [1920, 400],
  // dimensions: [600, 600],
  // dimensions: [410, 935], //punch card aspect ratio
  // dimensions: "a4",
  dimensions: features.dimensions == "square" ? [800, 800] : "a4",
  orientation: features.dimensions == "portrait" ? "portrait" : "landscape",
  pixelsPerInch: 150,
  fps: 8,
  playbackRate: "throttle",

  // pixelated: true
};

// console.log(settings.dimensions, settings.orientation)

window.$fxhashFeatures = {
  ratio: features.dimensions,
  "color mode": features.colorMode,
  "grid size": features.gridSize,
  margin: features.margin,
  scale: features.scale,
};

const getPointScale = () => {
  switch (features.scale) {
    case "smol":
      return {
        radius: 0.05,
        max: 60,
      };
    case "big":
      return {
        radius: 0.025,
        max: 120,
      };
  }
};

const scales = getPointScale();

console.log(scales);

const mods = [
  { name: "ok mountain 7ft", mods: [6, 56, 20] },
  { name: "ok minimalistic geometry peak", mods: [0, 13, 15] },
  { name: "superb cleaf", mods: [17, 53, 6] },
  { name: "superb cleaf", mods: [random.rangeFloor(16.5, 17.5), 53, 6] },
  { name: "superb tron epic", mods: [4, 0, 10] },
  {
    name: "superb tron epic",
    mods: [
      random.range(4, 4.1),
      random.range(0, 0.1),
      random.range(9.99, 10.1),
    ],
  },

  { name: "nice triangle piles", mods: [9, 30, 13] },
  { name: "ok dunes", mods: [9, 30, 13] },
  { name: "ok mntn", mods: [77, 80, 19] },
  { name: "ok snow gorge", mods: [77, 80, 19] },
  { name: "superb Euclid plateau", mods: [76, 66, 3] },
];

let [modA, modB, modC] = random.pick(mods).mods;

// bad
//{ name: "soso hacked mntn", mods: [2, 94, 5] },

// 9.001297312204265 24.412773845238807 63.51516632721411 - CA
// 30.246126738240914 19.80890168110451 32.3010486859806 - beauty forest
// 27.76 68.77 32.09
// 12.58 23.42 34.26
// 86.28 45.1 75.44
// 12.58 49.43 60.27
//  17.820631443340368 18.257954663530338 138.49761132919681

modA = Math.abs(random.gaussian()) * Math.PI * 5 + 15;
modB = Math.abs(random.gaussian()) * Math.PI * 2 + 10;
modC = Math.abs(random.gaussian()) * 100;

// let widthModifier = random.rangeFloor(50, 1000);
console.log("mods: ", modA, modB, modC);

// modA = 7;
// modB = 5;
// modC = 3;

// modA = 17.820631443340368;
// modB = 18.257954663530338;
// modC = 138.49761132919681;

// let

const isGrid = random.weightedSet([
  { value: true, weight: 80 },
  { value: false, weight: 2000 },
]); // backthought
const isGridFull = random.weightedSet([
  { value: true, weight: 30 },
  { value: false, weight: 70 },
]); // backthought

const isVertical = random.weightedSet([
  { value: true, weight: 100 },
  { value: false, weight: 0 },
]);
const isHorizontal = random.weightedSet([
  { value: true, weight: 100 },
  { value: false, weight: 0 },
]);
const isNoise = false;
const isIdeasConnected = random.weightedSet([
  { value: true, weight: 40 },
  { value: false, weight: 60 },
]); // tangled / complex
const margin = 150;

let quant = 10

// Gravitational constant and central mass - tune these for different effects
const G_PHYSICS = 0.1; // Adjusted for smaller scale forces initially
const CENTRAL_MASS = 5000; // Mass of the central attracting point
const PHYSICS_DELTA_TIME = 0.1; // Time step for physics simulation

const sketch = ({ context, width, height, render }) => {
  let widthModifier = width / quant + random.rangeFloor(0, 10);
  let heightModifier = height / quant + random.rangeFloor(0, 10);

  const size = random.weightedSet([{value: 0.1, weight: 10},{value: 0.8, weight: 10}, {value: 0.35, weight: 20}])

  const createGrid = (max_grid_density) => {
    const points = [];
    const count = random.rangeFloor(1, max_grid_density); // max_grid_density determines grid size

    const centerX_local = width / 2;
    const centerY_local = height / 2;

    for (let x_coord = 0; x_coord < count; x_coord++) {
      for (let y_coord = 0; y_coord < count; y_coord++) {
        const u_norm = count <= 1 ? 0.5 : x_coord / (count - 1);
        const v_norm = count <= 1 ? 0.5 : y_coord / (count - 1);

        const px_initial = lerp(margin, width - margin, u_norm);
        const py_initial = lerp(margin, height - margin, v_norm);

        const baseNoiseVal = random.noise2D(u_norm * 10, v_norm * 10);
        // Ensure radius is not excessively large initially; size is already a small factor.
        const calculatedRadius = Math.abs(baseNoiseVal) * size * Math.min(width, height) * 0.1;


        let bodyMass = Math.max(1, (calculatedRadius) * 5); // Mass proportional to radius area, tune factor

        let initial_vx = 0;
        let initial_vy = 0;

        const distToCenterX = px_initial - centerX_local;
        const distToCenterY = py_initial - centerY_local;
        const distToCenterVal = Math.sqrt(distToCenterX * distToCenterX + distToCenterY * distToCenterY);

        if (distToCenterVal > 10) { // Avoid extreme speeds near center
          const angleToCenter = Math.atan2(distToCenterY, distToCenterX);
          // Softer initial speed, tangential to center
          const initialSpeedMag = Math.sqrt((G_PHYSICS * CENTRAL_MASS) / distToCenterVal) * random.range(0.1, 0.3);

          initial_vx = -Math.sin(angleToCenter) * initialSpeedMag;
          initial_vy = Math.cos(angleToCenter) * initialSpeedMag;

          // Add some randomness to initial velocities for variety
          initial_vx += random.gaussian() * 0.1 * initialSpeedMag;
          initial_vy += random.gaussian() * 0.1 * initialSpeedMag;

        } else {
          // Small random push for points starting near center
          initial_vx = random.range(-0.5, 0.5);
          initial_vy = random.range(-0.5, 0.5);
        }

        points.push({
          radius: calculatedRadius / Math.min(width, height), // Store radius as normalized factor
          position: [px_initial, py_initial],
          mass: bodyMass,
          vx: initial_vx,
          vy: initial_vy,
          rotation: baseNoiseVal * Math.PI * 2,
          color: random.weightedSet([
            { value: "#F8D549", weight: 10 },
            { value: "#FAF9F4", weight: 30 },
            { value: "#394C8C", weight: 10 },
            { value: "#BF2F27", weight: 10 },
            { value: "black", weight: 20 },
          ]),
          timeOffset: random.range(0, Math.PI * 2),
          timeSpeed: random.range(0.5, 2),
          noiseScale: random.range(0.5, 2),
          isBrush: random.chance(0.1),
          baseNoise: baseNoiseVal,
          shapeNoise: random.noise2D(u_norm * 20, v_norm * 20)
        });
      }
    }
    return points;
  };

  const direction = random.boolean();

  const index = (r, c) =>
    direction ? (r * width + c) << 2 : (r * width - c) << 2;
  const dither = (pixels, r, c, k) => {
    const i = index(r, c) + k;
    const v = pixels[i];
    const vn = 255 - v < 255 >> 1 ? 255 : 0;
    const rem = v - vn;
    pixels[i] = vn;
    if (c < width - 1) pixels[index(r, c + 1) + k] += (rem >> 4) * modA;

    if (r < height - 1 && c < width - 1)
      pixels[index(r + 1, c + 1) + k] += rem >> 4;
    if (r < height - 1) pixels[index(r + 1, c) + k] += (rem >> 4) * modB;
    if (r < height - 1 && c > 0)
      pixels[index(r + 1, c - 1) + k] += (rem >> 4) * modC;
  };

  let points;
  // low mid high
  // 0.1 0.5 0.99
  const createPoints = () => {
    const threshold = random.weightedSet([
      {
        value: 0.8, // Keeps ~20% of points
        weight: 70,
      },
      {
        value: 0.95, // Keeps ~5% of points
        weight: 30,
      },
    ]);

    // Reduce max_grid_density from 100 to 20 to generate fewer initial points
    points = createGrid(20).filter(() => random.value() > threshold);
    if (points.length < 10) {
      createPoints(); // Recursive call, ensures we have at least 10 points
    }
  };
  createPoints();

  // filterPoints(); // Commented out as requested: "не лимитируй количество точек"

  let grainStrength = 1.5;
  borderGrainStrength = 2;

  const manipulatePixels = (time) => {
    // Fetch image data for the standard canvas width and height
    const imageDataObj = context.getImageData(0, 0, width, height);
    const pixelsArray = imageDataObj.data;
    const currentImageHeight = imageDataObj.height; // Use the actual height of the image data obtained
    const currentImageWidth = imageDataObj.width; // Use the actual width for clarity

    // The 'dither' function uses the sketch's 'width' and 'height' for its internal indexing,
    // which will align with the dimensions of imageDataObj since we used width/height in getImageData.

    // Iterate rows up to the actual height of the fetched image data.
    // The original loop for columns 'c' only went up to (sketch) width/2. We'll keep that for now.
    for (let r = 0; r < currentImageHeight; ++r) {
      for (let c = 0; c < currentImageWidth / 2; ++c) {
        dither(pixelsArray, r, c, 2); // Blue component
        dither(pixelsArray, r, c, 1); // Green component
        dither(pixelsArray, r, c, 0); // Red component

        // 2 1 0 - default
        // 2 0 - green (bad)
        // 1 0 - blue
        // 2 1 - red

        // switch (colorMode) {
        //   case "a":
        //     dither(data.data, r, c, 1);
        //     dither(data.data, r, c, 2);
        //     break;

        //   case "b":
        //     dither(data.data, r, c, 0);
        //     dither(data.data, r, c, 2);
        //     dither(data.data, r, c, 1);
        //     break;

        //   case "c":
        //     dither(data.data, r, c, 0);
        //     dither(data.data, r, c, 1);
        //     break;
        // }
      }
    }
    context.putImageData(imageDataObj, 0, 0);
  };

  // const bg = "#2B2B2B";
  // const bg = "#EFE7D7";
  const bg = random.weightedSet([
    {value:"black", weight: 50},
    {value:"white", weight: 50}
    // {value:"#e1e1e1", weight: 10}, // Original light gray, removed
    // {value:"black", weight: 10}, // Original black, weight adjusted
    // {value:"transparent", weight: 1000}, // Original transparent, removed
    // {value: 'white', weight: 100} // Original white, weight adjusted
  ]);
  let lineStrokeStyle = "rgba(0,0,0,0.15)";
  let bgStrokeStyle = "rgba(0,0,0,0.1)";
  let noiseStrokeStyle = "rgba(0,0,0,0.1)";

   lineStrokeStyle = "rgba(244,244,244,0.2)";
   bgStrokeStyle = "rgba(244,244,244,0.05)";
   noiseStrokeStyle = "rgba(244,244,244,0.01)";

  return {
    render({ context, width, height, time }) {
      // --- Fading Trails Background ---
      const trailFadeAmount = 0.25; // Adjust for desired trail length (0.0 to 1.0). Higher = faster fade.

      if (bg === 'transparent') {
        // When the intended background is transparent, we fade by drawing a low-opacity black.
        // This makes existing pixels (the trails) dimmer.
        context.fillStyle = `rgba(0, 0, 0, ${trailFadeAmount})`;
        context.fillRect(0, 0, width, height);
      } else {
        // When there's a solid background color, fade by drawing that color
        // with low opacity over the previous frame.
        context.globalAlpha = trailFadeAmount;
        context.fillStyle = bg; // bg is the chosen background color like 'white', 'black', etc.
        context.fillRect(0, 0, width, height);
        context.globalAlpha = 1.0; // Reset globalAlpha for subsequent drawing
      }

      // --- Physics Update ---
      const centerX = width / 2;
      const centerY = height / 2;

      points.forEach(point => {
        const [px, py] = point.position;
        const dx_force = centerX - px;
        const dy_force = centerY - py;
        const distSq = dx_force * dx_force + dy_force * dy_force;
        const dist = Math.sqrt(distSq);

        if (dist > 1) { // Avoid division by zero or extreme forces if too close
          const forceMagnitude = (G_PHYSICS * CENTRAL_MASS * point.mass) / distSq;
          const ax = (dx_force / dist) * forceMagnitude / point.mass; // Acceleration
          const ay = (dy_force / dist) * forceMagnitude / point.mass;

          point.vx += ax * PHYSICS_DELTA_TIME;
          point.vy += ay * PHYSICS_DELTA_TIME;
        }

        // Optional: Velocity damping to prevent excessive speeds
        // point.vx *= 0.999;
        // point.vy *= 0.999;

        point.position[0] += point.vx * PHYSICS_DELTA_TIME;
        point.position[1] += point.vy * PHYSICS_DELTA_TIME;

        // Optional: Boundary conditions (e.g., wrap around, bounce)
        // if (point.position[0] < 0 || point.position[0] > width) point.vx *= -1;
        // if (point.position[1] < 0 || point.position[1] > height) point.vy *= -1;
      });

      if (isNoise) {
        // draw many random points on canvas
        for (let i = 0; i < 100000; i++) {
          const x = random.range(margin, width - margin);
          const y = random.range(margin, height - margin);
          context.beginPath();
          context.arc(x, y, 1, 0, Math.PI * 2);
          // mb coloured dots?
          context.fillStyle = noiseStrokeStyle;
          context.fill();
        }
      }

      // draw vertial and horizontal lines with center in points coordinates
      // crosshair
      if (false) {
        context.beginPath();
        context.strokeStyle = noiseStrokeStyle;
        for (let i = 0; i < points.length; i++) {
          const { position, radius } = points[i];
          const [x, y] = position;
          context.moveTo(x, y - radius * height);
          context.lineTo(x, y + radius * height);
          context.moveTo(x - radius * width, y);
          context.lineTo(x + radius * width, y);
        }
        context.stroke();
      }

      // context.beginPath();
      // context.strokeStyle = strokeStyle
      // for (let i = 0; i < points.length; i++) {
      //   const { position, radius } = points[i];
      //   const [x, y] = position;
      //   context.moveTo(x, 0);
      //   context.lineTo(x, height);
      //   context.moveTo(x - radius * width, y);
      //   context.lineTo(x + radius * width, y);
      // }
      // context.stroke();

      if (isGrid) {
        context.beginPath();
        context.strokeStyle = lineStrokeStyle;
        for (let i = 0; i < points.length; i++) {
          const { position } = points[i];
          const [x, y] = position;
          // *** vertical lines ***
          if (isVertical) {
            if (random.boolean()) {
              context.moveTo(x, !isGridFull ? random.rangeFloor(0, margin) : 0);
              context.lineTo(
                x,
                height - (!isGridFull ? random.rangeFloor(0, margin) : 0)
              );
            }
          }
          if (isHorizontal) {
            // *** horizontal lines ***
            // optional torn edge
            if (random.boolean()) {
              context.moveTo(!isGridFull ? random.rangeFloor(0, margin) : 0, y);
              context.lineTo(
                width - (!isGridFull ? random.rangeFloor(0, margin) : 0),
                y
              );
            }
          }
        }
        context.stroke();
      }

      // context.beginPath();
      // context.strokeStyle = strokeStyle
      // points.forEach((point) => {
      //   const { radius, position, color, rotation } = point;
      //   const [x, y] = position;
      //   console.log(x, y);
      //   if (radius * width > 5) {
      //     context.moveTo(x, y);
      //     context.lineTo(width - x, height - y);
      //   }
      // });
      // context.stroke();

      if (false) {
        // draw lines from points to center
        context.beginPath();
        context.strokeStyle = bgStrokeStyle;
        points.forEach((point) => {
          const { radius, position, color, rotation } = point;
          const [x, y] = position;
          if (radius * width > 10) {
            context.moveTo(x, y);
            context.lineTo(width / 2, height / 2);
          }
        });
        context.stroke();
      }

      if (isIdeasConnected) {
        // connect random points with lines
        context.beginPath();
        context.strokeStyle = bgStrokeStyle;
        for (let i = 0; i < points.length; i++) {
          const point = points[i];
          const { radius, position, color, rotation } = point;
          if (radius * width > 10) {
            const [x, y] = position;
            const other = points[random.rangeFloor(0, points.length)];
            const [x2, y2] = other.position;

            // draw radius number
            // context.font = "10px Arial";
            // context.fillStyle = "black";
            // context.fillText(radius, x, y);

            context.moveTo(x, y);
            context.lineTo(x2, y2);
          }
        }
        context.stroke();
      }

      for (var i = 0; i < points.length; i++) {
        const {
          radius, // This is now a normalized factor
          position, // Updated by physics
          color,
          rotation,
          timeOffset,
          timeSpeed,
          noiseScale,
          isBrush,
          baseNoise,
          shapeNoise
        } = points[i];
        const [current_x, current_y] = position; // Use current, physics-updated position

        // Используем индивидуальные временные параметры для каждого объекта
        const objectTime = time * timeSpeed + timeOffset;
        // Apply noise to the current physical position for the "wobble" effect
        const noiseX = random.noise2D(current_x * 0.01, objectTime * 0.5) * 20 * noiseScale;
        const noiseY = random.noise2D(current_y * 0.01, objectTime * 0.5) * 20 * noiseScale;
        const noiseRotation = random.noise2D(current_x * 0.01, current_y * 0.01 + objectTime * 0.5) * Math.PI * 2 * noiseScale;


        // Для кистей используем полупрозрачный цвет
        const brushColor = isBrush ? color.replace(')', ', 0.3)').replace('rgb', 'rgba') : color;

        // Только определяем, будет ли круг заполненным
        const isFilled = Math.abs(baseNoise) > 0.1;

        const displayRadius = radius * Math.min(width, height); // Convert normalized radius to pixels for drawing

        // Всегда рисуем круги
        context.beginPath();
        context.arc(current_x + noiseX, current_y + noiseY, displayRadius, 0, Math.PI * 2, false);
        context.fillStyle = isBrush ? brushColor : color;

        context.save();
        context.translate(current_x + noiseX, current_y + noiseY);
        context.rotate(rotation + noiseRotation); // Apply original rotation + noise rotation
        context.beginPath();
        // Draw shape relative to 0,0 after translate/rotate
        context.arc(0, 0, displayRadius, 0, Math.PI * 2, false);
        context.fillStyle = isBrush ? brushColor : color;

        if (isFilled) context.fill();
        else {
          context.strokeStyle = isBrush ? brushColor : color;
          context.lineWidth = Math.max(1, displayRadius * 0.1); // Thinner stroke for outline
          context.stroke();
        }
        context.restore();
      }

      // Dithering effect applied last, will interact with trails
      manipulatePixels(time);
    },
  };
};

canvasSketch(sketch, settings);

// fxpreview();
